import "./menu.scss";

export default function Menu({menuOpen, setMenuOpen}){
    const menuOptions = [
        {
            id:1,
            title:"Intro",
            link:"#intro"
        },
        {
            id:1,
            title:"Skills",
            link:"#skills"
        },
        {
            id:1,
            title:"Experience",
            link:"#works"
        },
        {
            id:1,
            title:"Projects",
            link:"#portfolio"
        },
        {
            id:1,
            title:"Contact",
            link:"#contact"
        },

    ];
    return(
        <div className={"menu "+ (menuOpen && "active")} id="menu">
            <ul>
                {
                    menuOptions.map((option) => {
                        return(
                            <li onClick={() => setMenuOpen(!menuOpen)}><a href={option.link}>{option.title}</a></li>
                        )
                    })
                }
                {/* <li onClick={() => setMenuOpen(!menuOpen)}><a href="#intro">Intro</a></li>
                <li onClick={() => setMenuOpen(!menuOpen)}><a href="#qualification">Qualification</a></li>
                <li onClick={() => setMenuOpen(!menuOpen)}><a href="#portfolio">Portfolio</a></li>
                <li onClick={() => setMenuOpen(!menuOpen)}><a href="#works">Works</a></li>
                <li onClick={() => setMenuOpen(!menuOpen)}><a href="#testimonials">Testimonials</a></li>
                <li onClick={() => setMenuOpen(!menuOpen)}><a href="#contact">Contact</a></li> */}
            </ul>
        </div>
    )
}